export default __webpack_public_path__ + "ocr-certificates5f8f72.png";